import { MODALITIES } from '@vindr/services/constants/study.constant';
import { AxiosResponse } from 'axios';
import api from '../api';
import { GENDER } from '../constants/common.constant';
import { SORT_ORDER } from '../constants/filter.constant';
import {
  CAD_STATUS,
  MATCH_STATUS,
  STUDYLIST_STATUS,
  STUDY_STATUS,
} from '../constants/study.constant';
import { DefaultResponse } from '../interfaces/index';

export interface ParamsStudyList {
  body_part?: string;
  diagnostic?: string;
  filter_id?: string;
  institution_ids?: string[];
  is_dicom?: boolean;
  limit?: number;
  match_status?: MATCH_STATUS;
  modality?: MODALITIES;
  offset?: number;
  order_doctor_name?: string;
  order_group?: string;
  patient_age?: string;
  patient_id?: string;
  patient_name?: string;
  patient_sex?: GENDER;
  procedure_code?: string;
  procedure_name?: string;
  refer_doctor_name?: string;
  sort_field?: '' | 'study_date';
  sort_order?: SORT_ORDER;
  source_aetitle?: string;
  study_date_from: string;
  study_date_to: string;
  study_desc?: string;
  study_id?: string;
  study_instance_uid?: string;
  study_status?: STUDY_STATUS;
  studylist_status?: STUDYLIST_STATUS;
  visit_id?: string;
}
export interface ResponseFetchStudyList extends DefaultResponse {
  data: {
    abnormal_status: CAD_STATUS;
    body_part: string[];
    device_id: string;
    diagnostic: string[];
    instances_count: number;
    institution_id: string;
    is_dicom: boolean;
    match_status: MATCH_STATUS;
    modality: string[];
    order_doctor_name: string[];
    order_group: string[];
    patient_age: string;
    patient_birth_date: string;
    patient_id: string;
    patient_name: string;
    patient_sex: GENDER;
    procedure_code: string[];
    procedure_name: string[];
    refer_doctor_name: string[];
    series_count: number;
    study_date: string;
    study_desc: string[];
    study_id: string;
    study_instance_uid: string;
    study_status: STUDY_STATUS;
    studylist_status: STUDYLIST_STATUS;
    visit_id: string;
  }[];
}
export const fetchStudyList = async (params: ParamsStudyList) => {
  const response = (await api({
    url: '/studies/v1/studylist',
    method: 'GET',
    params,
    timeout: 30_000,
  })) as AxiosResponse<ResponseFetchStudyList>;

  return response.data;
};

export const getDetailStudy = async (params: ParamsStudyList) => {
  const response = (await api({
    url: '/studies/v1/studylist',
    method: 'GET',
    timeout: 30_000,
    params: { limit: 1, offset: 0, ...params },
  })) as AxiosResponse<ResponseFetchStudyList>;

  return response.data;
};

export interface ParamsCreatePreStudy {
  accession_no: string;
  body_parts?: string[];
  comment?: string;
  dcm_patient_id: string;
  department?: string;
  desc?: string;
  device_id: string;
  institution_id: string;
  order_id: string;
  patient_birth_date?: string;
  patient_name: string;
  patient_sex: string;
  ref_doctor?: string;
  visit_id: string;
}

export interface ResponseCreatePreStudy extends DefaultResponse {
  data: {
    study_instance_uid: string;
    institution_id: string;
    patient_id: string;
    visit_id: string;
    patient_name: string;
    patient_sex: number;
    patient_birth_date: string;
    patient_age: string;
    order_group: null;
    body_part: null;
    series_count: number;
    instances_count: number;
    modality: null;
    study_date: string;
    study_desc: null;
    study_status: number;
    procedure_code: null;
    procedure_name: null;
    order_doctor_name: null;
    refer_doctor_name: null;
    diagnostic: null;
    is_dicom: boolean;
    study_id: string;
    match_status: number;
    studylist_status: number;
    device_id: string;
    abnormal_status: number;
    study_comment: string;
    department: string;
  };
}
export const createPreStudy = async (data: ParamsCreatePreStudy) => {
  const response = (await api({
    url: `studies/v1/pre-study`,
    method: 'POST',
    data,
  })) as AxiosResponse<ResponseCreatePreStudy>;

  return response.data;
};
